<template>
  <div>
    <!-- Alert: No item found -->
    <b-breadcrumb class="breadcrumb-slash mb-1">
      <b-breadcrumb-item :to="{ name: 'member-list' }">
        ข้อมูลสมาชิก (ผู้ซื้อ)
      </b-breadcrumb-item>
      <b-breadcrumb-item active>
        ดูข้อมูล
      </b-breadcrumb-item>
    </b-breadcrumb>

    <b-alert variant="danger" :show="userData === undefined">
      <h4 class="alert-heading">
        Error fetching user data
      </h4>
      <div class="alert-body">
        No user found with this user id. Check
        <b-link class="alert-link" :to="{ name: 'apps-users-list' }">
          User List
        </b-link>
        for other users.
      </div>
    </b-alert>

    <template v-if="userData">
      <!-- First Row -->
      <b-row>
        <b-col cols="12" xl="12" lg="12" md="12">
          <user-view-user-info-card :user-data="userData" />
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" lg="6">
          <user-view-user-permissions-card :user-data="userData" />
        </b-col>
        <b-col cols="12" lg="6">
          <user-view-user-timeline-card :user-data="userData" />
        </b-col>
      </b-row>

      <!-- <invoice-list /> -->
      <orders-list :contract-id="userData.contactId" />
    </template>
  </div>
</template>

<script>
import store from "@/store";
import router from "@/router";
import { ref, onUnmounted } from "@vue/composition-api";
import {
  BRow,
  BCol,
  BAlert,
  BLink,
  BBreadcrumb,
  BBreadcrumbItem,
} from "bootstrap-vue";
import InvoiceList from "@/views/orders/invoice/invoice-list/InvoiceList.vue";
import userStoreModule from "../userStoreModule";
import UserViewUserInfoCard from "./MemberViewUserInfoCard.vue";
import UserViewUserTimelineCard from "./MemberViewUserTimelineCard.vue";
import UserViewUserPermissionsCard from "./MemberViewUserPermissionsCard.vue";
import OrdersList from "./OrdersList.vue";

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,

    // Local Components
    UserViewUserInfoCard,
    UserViewUserTimelineCard,
    UserViewUserPermissionsCard,

    InvoiceList,
    OrdersList,
    BBreadcrumb,
    BBreadcrumbItem,
  },
  setup() {
    const userData = ref(null);

    const USER_APP_STORE_MODULE_NAME = "app-user-mock";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    // store
    //   .dispatch("app-user-mock/fetchUserOld", { id: 21 })
    //   .then((response) => {
    //     userData.value = response.data;
    //   })
    //   .catch((error) => {
    //     if (error.response.status === 404) {
    //       userData.value = undefined;
    //     }
    //   });

    store
      .dispatch("members/fetchUser", { id: router.currentRoute.params.id })
      .then((response) => {
        console.log("response", response.data);
        userData.value = response.data;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          userData.value = undefined;
        }
      });

    return {
      userData,
    };
  },
};
</script>

<style></style>
